module.exports = __webpack_public_path__ + "static/media/brochure-header-tire-tracks.b3e75949.webp";